import { BehaviorSubject } from 'rxjs';
import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';

import * as ɵngcc0 from '@angular/core';
class DualContentService {
    constructor() {
        this.contentShow$ = new BehaviorSubject('none');
        this.isMobile = this.getIsModile;
        if (this.isMobile) {
            this.setContentType = 'A';
        }
    }
    get getIsModile() {
        return window.innerWidth < 992;
    }
    get getContentType() {
        return this.contentShow$.asObservable();
    }
    set setContentType(contentTypes) {
        this.contentShow$.next(contentTypes);
    }
    setMinContentWidthModile(contentWidth) {
        if (!this.isMobile) {
            this.minContentWidth = 'auto';
            return;
        }
        if (contentWidth) {
            this.minContentWidth = `${contentWidth - 26}px`;
        }
    }
    getClassesForContentModeC(contentType) {
        const classesContentMobile = 'col s12 p1 ';
        if (this.isMobile) {
            return classesContentMobile;
        }
        if (contentType === 'A') {
            return 'col s4 m-r1 p1';
        }
        return 'col s8 p1';
    }
    changeContent(contentType) {
        this.setContentType = contentType;
    }
}
DualContentService.ɵfac = function DualContentService_Factory(t) { return new (t || DualContentService)(); };
DualContentService.ɵprov = i0.ɵɵdefineInjectable({ factory: function DualContentService_Factory() { return new DualContentService(); }, token: DualContentService, providedIn: "root" });
DualContentService.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DualContentService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

export { DualContentService };

//# sourceMappingURL=aw-ads-components-src-services-dual-content.js.map